var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32 63c-14.7 0-26.7-12-26.7-26.7 0-1.1.9-2 2-2s2 .9 2 2c0 12.5 10.2 22.7 22.7 22.7s22.7-10.2 22.7-22.7-10.2-22.7-22.7-22.7c-1.1 0-2-.9-2-2s.9-2 2-2c14.7 0 26.7 12 26.7 26.7s-12 26.7-26.7 26.7z",
    fill: "#022e45",
    "data-original": "#000000",
    className: ""
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36 22.6c-.5 0-1-.2-1.4-.6l-8.8-8.8c-.8-.8-.8-2 0-2.8l8.8-8.8c.8-.8 2-.8 2.8 0s.8 2 0 2.8l-7.4 7.4 7.4 7.4c.8.8.8 2 0 2.8-.3.4-.8.6-1.4.6z",
    fill: "#022e45",
    "data-original": "#000000",
    className: ""
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertIcon);
export default __webpack_public_path__ + "static/media/revert-icon.0682f22dd619c5c237cbec788297171b.svg";
export { ForwardRef as ReactComponent };